import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import moment from 'moment';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  },
  root: {
    padding: '12px 6px'
  }
}))(TableCell);

const formatLogDateTime = dateTime => {
  if (!dateTime) return '--';

  // Use moment to parse and format to UTC+7
  const formattedDate = moment(dateTime).utcOffset(7);

  if (!formattedDate.isValid()) return '--';

  return formattedDate.format('HH:mm:ss DD/MM/YYYY');
};

const Results = ({ className, listActionLogs, getListActionLogsRef }) => {
  const classes = useStyles();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const totalActionLogs = useSelector(state => state.customerSlice.totalActionLogs);

  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListActionLogsRef) return;
    const newparams = Object.assign({}, params, { page: newPage });
    setParams(newparams);
    getListActionLogsRef(newparams);
  };

  return (
    <>
      <Card className={clsx(classes.root, className)}>
          <div>
            <PerfectScrollbar>
              {listActionLogs && listActionLogs.length > 0 ? (
                <Box minWidth={1050} paddingLeft={3}>
                  <Table>
                    {listActionLogs?.length > 0 && (
                      <TableHead>
                        <TableRow>
                          <StyledTableCell style={{ width: 300 }}>Tên người dùng</StyledTableCell>
                          <StyledTableCell style={{ width: 200 }}>Hành động</StyledTableCell>
                          <StyledTableCell style={{ width: 600 }}>Thông tin</StyledTableCell>
                          <StyledTableCell style={{ width: 300 }}>Địa chỉ IP</StyledTableCell>
                          <StyledTableCell style={{ width: 150 }}>Thời gian cập nhật</StyledTableCell>
                        </TableRow>
                      </TableHead>
                    )}
                    <TableBody>
                      {listActionLogs.map((log, index) => (
                        <TableRow hover key={log.id}>
                          <StyledTableCell>
                            {log?.username || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {log?.action || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {log?.description || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {log?.ip_address || '--'}
                          </StyledTableCell>                  
                          <StyledTableCell>
                            {formatLogDateTime(log?.created_at)}
                          </StyledTableCell>         
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img src="/static/empty.png" class="justify-content-center" />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
      </Card>
      {listActionLogs && listActionLogs.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalActionLogs}
            </Typography>
            <Pagination
              count={Math.ceil(totalActionLogs / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listUser: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default Results;
